import { render, staticRenderFns } from "./UserLoginModal.vue?vue&type=template&id=79088b64"
import script from "./UserLoginModal.vue?vue&type=script&lang=js"
export * from "./UserLoginModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports